module.exports = __webpack_public_path__ + "img/Skirt-Back-B2-Da-Fc-Ga-Hc-Ia.90eaeaf8.png";